import { k } from "../kaplay";

import { attack } from "../components/attack";
import { properties } from "../data/properties";

export function addSpike(){
  const randX = k.randi(100, k.width() - 100);
  const randY = k.randi(100, k.height() - 100);

  const newSpike = k.add([
    "spike",
    "attack_enemy",

    k.sprite("spike"),
    k.pos(randX, randY),
    k.anchor("bot"),
    k.area(),
    k.layer("background"),
    k.scale(properties.spike.scale),
    attack({ damage: properties.spike.damage, attackFunc: async () => {
      await k.wait(0.5); 
      newSpike.destroy(); 
    } }),
  ])

  return newSpike;
}